module.exports = __webpack_public_path__ + "img/box_fill.51862b72.svg";